import "./common.css";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import logo from "../assets/images/logo/Ai_Tattoo_Logo.webp"

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const removeClass = () => {
    document.getElementById("togglesidebar").classList.remove("active_sidebar");
  };

  return (
    <>

      <div id="sidebar">
        <div className="sidebar_logo mx-auto">

          <img src={logo}
            alt="logo"
            className="rounded" />

          <i className="fa fa-close" onClick={removeClass}></i>

        </div>
        <div className="sidebar_menu">
          <ul className="m-0 p-0">
            <li>
              <Link
                to="/dashboard"
                className={location.pathname === "/dashboard" ? "active" : ""}
                onClick={removeClass}
              >
                <img
                  src={require("../assets/images/home.svg").default}
                  alt="home"
                />
                Home
              </Link>
            </li>

            <li>
              <Link
                to="/Inspirations"
                className={location.pathname === "/Inspirations" ? "active" : ""}
                onClick={removeClass}
              >
                <img
                  src={require("../assets/images/categories.svg").default}
                  alt="Inspirations"
                />
                Inspirations
              </Link>
            </li>
            <li>
              <Link
                to="/Styles"
                className={location.pathname === "/Styles" ? "active" : ""}
                onClick={removeClass}
              >
                <img
                  src={require("../assets/images/share.svg").default}
                  alt="references"
                />
                Styles
              </Link>
            </li>
            <li>
              <Link
                to="/tattoos"
                className={location.pathname === "/tattoos" ? "active" : ""}
                onClick={removeClass}
              >
                <img
                  src={require("../assets/images/dragon-icon.svg").default}
                  alt="tattoos"
                />
                Tattoos
              </Link>
            </li>
            <li>
              <Link
                to="/texttoimages"
                className={location.pathname === "/texttoimages" ? "active" : ""}
                onClick={removeClass}
              >
                <img
                  src={require("../assets/images/dragon-icon.svg").default}
                  alt="texttoimages"
                />
                Text To Images
              </Link>
            </li>
            <li>
              <Link
                to="/generate-thumb"
                className={location.pathname === "/generate-thumb" ? "active" : ""}
                onClick={removeClass}
              >
                <img
                  src={require("../assets/images/fire-icon.svg").default}
                  alt="tattoos"
                />
                Generate Thumb
              </Link>

            </li>

            <li>
              <Link
                to="/image-upload"
                className={location.pathname === "/image-upload" ? "active" : ""}
                onClick={removeClass}
              >
                <img
                  src={require("../assets/images/fire-icon.svg").default}
                  alt="tattoos"
                />
                Image Upload
              </Link>

            </li>


            <li>
              <Link
                to="/login"
                className={location.pathname === "" ? "active" : ""}
                onClick={() => {
                  localStorage.removeItem("token");
                  localStorage.removeItem("userData");
                  navigate('/login')
                }}
              >
                <img
                  src={require("../assets/images/logout.png")}
                  alt="help"
                />
                Logout
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="sidebar_overlay" onClick={removeClass}></div>
    </>
  );
};
export default Sidebar;
